import styled from 'styled-components'
import Box from 'web-makeup/dist/Box'

export const Heading = styled.header`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  align-items: center;
`

export const Filters = styled.ul`
  display: flex;
  align-items: center;
  list-style-type: none;

  > li {
    margin-left: 1rem;
  }
`

export const StyledBox = styled(Box)`
  max-width: 100%;
  padding: 2rem;
`

export const Title = styled.div`
  font-size: 1rem;
  font-weight: 700;
  color: #4a4a4a;
`



// WEBPACK FOOTER //
// ./src/components/ProducerRequests/ProducerRequests.style.tsx